import { useAuthState } from '@/app/providers/auth'
import Link from '@/components/Link'
import useTenant from '@/hooks/useTenant'
import { Close, Menu } from '@mui/icons-material'
import { Box, Button, IconButton } from '@mui/material'

import { usePathname } from 'next/navigation'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { match } from 'ts-pattern'

import { loggedInLinks } from './constants'

const Mobile: React.FC = () => {
  const pathname = usePathname()
  const authState = useAuthState()
  const tenant = useTenant()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return match({ authState, tenant })
    .with({ tenant: { permissions: { allowUserSignIn: false } } }, () => null)
    .with({ authState: { type: 'authenticated' } }, () => (
      <>
        <IconButton
          onClick={() => setOpen(!open)}
          sx={{
            ml: '6px',
            width: 30,
            height: 25,
            p: 0,
          }}>
          {open ? (
            <Close sx={{ fontSize: 16, color: 'primary.main' }} />
          ) : (
            <Menu sx={{ fontSize: 27, color: 'text.primary' }} />
          )}
        </IconButton>

        {open && (
          <Box
            sx={{
              position: 'fixed',
              top: '64px',
              left: 0,
              zIndex: 100,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'background.default',
              '& a': {
                textDecoration: 'none',
              },
            }}>
            {loggedInLinks.map((link) => (
              <Link href={link.url} key={link.name}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                  <Box
                    sx={{
                      width: '100%',
                      margin: 'auto',
                      padding: '24px',
                      textAlign: 'center',
                      backgroundColor: 'background.paper',
                      fontSize: (theme) => theme.typography.body1.fontSize,
                      fontWeight: 400,
                      borderTop: '1px solid',
                      borderColor: 'background.default',
                      color: link.color || 'text.primary',
                    }}>
                    {link.name}
                  </Box>
                </Box>
              </Link>
            ))}
          </Box>
        )}
      </>
    ))
    .with({ authState: { type: 'loading' } }, { authState: { type: 'unauthenticated' } }, () => (
      <Link href={`/authentication/login?destination=${pathname}`} passHref>
        <Button variant="contained" size="small">
          {t('marketplace:signIn')}
        </Button>
      </Link>
    ))
    .exhaustive()
}

export default Mobile
